<template>
    <div>
      <template>
        <main-top />
        <!--<home/>-->
        <div><router-view/></div>
        <main-bottom/>
      </template>
    </div>
</template>

<script>
    import MainTop from "./main-top";
    import MainBottom from "./main-bottom";
    import Home from "../views/modules/home";
    export default {
        name: "main1",
      components: {
          MainTop,
          Home,
        MainBottom
        },
      mounted: function () {

      },
      methods: {
        open(name){
          this.$router.push({ name: name});
        }
      }
    }
</script>

<style scoped>
.page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue